import { render, staticRenderFns } from "./location-read-emails-list.vue?vue&type=template&id=cbf2b8b8&scoped=true"
import script from "./location-read-emails-list.vue?vue&type=script&lang=js"
export * from "./location-read-emails-list.vue?vue&type=script&lang=js"
import style0 from "./location-read-emails-list.vue?vue&type=style&index=0&id=cbf2b8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf2b8b8",
  null
  
)

export default component.exports